module.exports = __webpack_public_path__ + "static/media/sucess_forgot.429019f1.jpg";